module.exports = __webpack_public_path__ + "static/media/project-1.fa4400dd.jpeg";